"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Channel = exports.Ssid = void 0;
const effect_1 = require("effect");
const NAMESPACE = 'Network.WiFi.Common';
exports.Ssid = effect_1.Schema.String.pipe(effect_1.Schema.maxLength(32)).annotations({
    identifier: `${NAMESPACE}.Ssid`,
});
exports.Channel = effect_1.Schema.Int.pipe(effect_1.Schema.positive()).annotations({ identifier: `${NAMESPACE}.Channel` });
//# sourceMappingURL=common.js.map